export interface OverlapLayoutSlice {
    width: string;
    left: string;
}

/**
 * Computes width/left for items sharing a time/room slot.
 * When expandedIndex >= 0, the hovered item grows and siblings compress into side strips.
 */
export function getOverlapGroupLayout(
    groupSize: number,
    indexInGroup: number,
    expandedIndex: number = -1
): OverlapLayoutSlice {
    if (groupSize <= 1) {
        return { width: '100%', left: '0%' };
    }

    if (expandedIndex < 0) {
        const itemWidthPercent = 100 / groupSize;
        return {
            width: `${itemWidthPercent}%`,
            left: `${indexInGroup * itemWidthPercent}%`,
        };
    }

    const stripPercent = Math.min(15, 80 / (groupSize + 1));
    const expandedPercent = 100 - (groupSize - 1) * stripPercent;

    if (indexInGroup === expandedIndex) {
        return {
            width: `${expandedPercent}%`,
            left: `${indexInGroup * stripPercent}%`,
        };
    }

    if (indexInGroup < expandedIndex) {
        return {
            width: `${stripPercent}%`,
            left: `${indexInGroup * stripPercent}%`,
        };
    }

    const left = expandedIndex * stripPercent
        + expandedPercent
        + (indexInGroup - expandedIndex - 1) * stripPercent;

    return {
        width: `${stripPercent}%`,
        left: `${left}%`,
    };
}
